var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_1393)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_429_1393",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0H0.5V30H30.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_429_1393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 1.87549C10.8433 1.87549 7.0625 5.65633 7.0625 10.313C7.0625 11.6363 7.75083 13.793 8.75792 16.1518C10.9833 21.3643 14.6921 27.6639 14.6921 27.6639C14.8608 27.9497 15.1679 28.1255 15.5 28.1255C15.8321 28.1255 16.1392 27.9497 16.3079 27.6639C16.3079 27.6639 20.0167 21.3643 22.2421 16.1518C23.2492 13.793 23.9375 11.6363 23.9375 10.313C23.9375 5.65633 20.1567 1.87549 15.5 1.87549ZM15.5 25.3051C16.6992 23.1851 18.9729 19.0334 20.5179 15.4155C21.4009 13.3472 22.0625 11.4734 22.0625 10.313C22.0625 6.69091 19.1221 3.75049 15.5 3.75049C11.8779 3.75049 8.9375 6.69091 8.9375 10.313C8.9375 11.4734 9.59917 13.3472 10.4821 15.4155C12.0271 19.0334 14.3008 23.1851 15.5 25.3051Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.499 12.1865C14.4642 12.1865 13.624 11.3463 13.624 10.3115C13.624 9.27665 14.4642 8.4365 15.499 8.4365C16.5338 8.4365 17.374 9.27665 17.374 10.3115C17.374 10.5305 17.3366 10.7407 17.2674 10.9362C17.0947 11.424 17.3507 11.9601 17.8383 12.1327C18.3261 12.3054 18.8622 12.0496 19.0349 11.5618C19.1733 11.1705 19.2489 10.7498 19.2489 10.3115C19.2489 8.24182 17.5687 6.56152 15.499 6.56152C13.4293 6.56152 11.749 8.24182 11.749 10.3115C11.749 12.3812 13.4293 14.0614 15.499 14.0614C16.0163 14.0614 16.4365 13.6413 16.4365 13.124C16.4365 12.6066 16.0163 12.1865 15.499 12.1865Z",
    fill: "#FF0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_1393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetLocation);
export default __webpack_public_path__ + "static/media/Get_Location.7e8c591640326d311747d28b23412238.svg";
export { ForwardRef as ReactComponent };